import { render, staticRenderFns } from "./SettingsCompanyUniqueIdentifierView.vue?vue&type=template&id=5cdba77e&scoped=true&"
import script from "./SettingsCompanyUniqueIdentifierView.vue?vue&type=script&lang=js&"
export * from "./SettingsCompanyUniqueIdentifierView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCompanyUniqueIdentifierView.vue?vue&type=style&index=0&id=5cdba77e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdba77e",
  null
  
)

export default component.exports